import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import SaudeService from '../../../../../../services/saude-auth';
import { Link } from 'react-router-dom';
import '../../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchRemumes()
            setNome("")
        } else {
            var response = await SaudeService.buscarRemume(query)
            if (response.data.length >= 1) {
                props.setRemumes(response.data)
                props.setVazio(false)
                setNome("")

            } else {
                props.setVazio(true)
                setNome("")

            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome !== "false" && nome != "false" && nome !== "") prepQuery = prepQuery + `&nome=${encodeURI(nome)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Medicamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/saude/remume'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
